module.exports = __webpack_public_path__ + "img/maria.4775f1ce.jpeg";